/**
 * Simplified Chinese translations
 */

import type { TranslationStrings } from '../types';

export const zhCN: TranslationStrings = {
  toolbar: {
    activate: '激活 agent-ui-annotation',
    freeze: '冻结动画',
    unfreeze: '解除冻结',
    showMarkers: '显示标记',
    hideMarkers: '隐藏标记',
    dotsMode: '仅显示圆点',
    copyToClipboard: '复制到剪贴板',
    clearAll: '清除全部',
    annotations: '标注列表',
    toggleTheme: '切换主题',
    settings: '设置',
    close: '关闭',
    copiedFeedback: '已复制到剪贴板!',
    clearedFeedback: '已清除所有标注',
  },
  popup: {
    close: '关闭',
    addFeedback: '添加您的反馈...',
    addFeedbackMulti: '为所有选中元素添加反馈...',
    cancel: '取消',
    delete: '删除',
    save: '保存',
    addAnnotation: '添加标注',
    addAnnotations: '添加 {{count}} 个标注',
    elementsSelected: '已选择 {{count}} 个元素',
    andMore: '...以及其他 {{count}} 个',
  },
  settings: {
    title: '设置',
    outputLevel: '输出级别',
    markerColor: '标记颜色',
    blockInteractions: '阻止页面交互',
    blockInteractionsHint: '标注时阻止点击激活按钮/链接',
    showTooltips: '显示工具提示',
    autoClearAfterCopy: '复制后自动清除',
    outputLevels: {
      compact: '简洁',
      standard: '标准',
      detailed: '详细',
      forensic: '完整',
    },
  },
  colors: {
    purple: '紫色',
    blue: '蓝色',
    cyan: '青色',
    green: '绿色',
    yellow: '黄色',
    orange: '橙色',
    red: '红色',
  },
  marker: {
    noComment: '(无备注)',
  },
  output: {
    pageFeedback: '页面反馈',
    noAnnotations: '未创建标注。',
    viewport: '视口',
    annotations: '标注',
    location: '位置',
    selectedText: '选中文本',
    feedback: '反馈',
    component: '组件',
    domPath: 'DOM 路径',
    selector: '选择器',
    elementDetails: '元素详情',
    tag: '标签',
    id: 'ID',
    classes: '类名',
    attributes: '属性',
    textContent: '文本内容',
    positionDimensions: '位置与尺寸',
    boundingBox: '边界框',
    size: '尺寸',
    accessibility: '无障碍',
    role: '角色',
    interactive: '可交互',
    ariaLabel: 'ARIA 标签',
    describedBy: '描述来源',
    tabIndex: 'Tab 索引',
    computedStyles: '计算样式',
    context: '上下文',
    landmark: '地标',
    parent: '父元素',
    previousSibling: '前一个兄弟元素',
    nextSibling: '后一个兄弟元素',
    multiSelectNote: '通过多选创建',
    metadata: '元数据',
    created: '创建时间',
    updated: '更新时间',
    environment: '环境',
    url: 'URL',
    devicePixelRatio: '设备像素比',
    scrollPosition: '滚动位置',
    timestamp: '时间戳',
    userAgent: '用户代理',
    totalAnnotations: '标注总数',
    yes: '是',
    no: '否',
    none: '无',
  },
};
